import { Controller } from "@hotwired/stimulus"

const BREAK_MINUTES = 30

export class ManualBreakFormController extends Controller {
  static targets = ["start", "end"]

  follow() {
    const match = this.startTarget.value.match(/^([01]?\d|2[0-3]):([0-5]\d)$/)
    if (!match) return

    // A fixed winter day: no daylight-saving change can shift the hour.
    const end = new Date(2000, 0, 1, Number(match[1]), Number(match[2]) + BREAK_MINUTES)
    this.endTarget.value = end.toTimeString().slice(0, 5)
  }
}
